import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useFetchTeams } from 'actions/team';
export function getUniqueNonNullOwningTeams(owningTeamIds) {
  return _toConsumableArray(new Set(owningTeamIds)).filter(Boolean); // Type casting as TS otherwise thinks it's an array of IdType | null
}
export function useGetDefaultOwningTeamNames(defaultOwnerTeamIds) {
  var _useFetchTeams = useFetchTeams({
      teamIds: getUniqueNonNullOwningTeams(defaultOwnerTeamIds)
    }),
    _useFetchTeams$items = _useFetchTeams.items,
    defaultOwningTeams = _useFetchTeams$items === void 0 ? [] : _useFetchTeams$items;
  var defaultOwningTeamNames = defaultOwnerTeamIds.length > 0 ? defaultOwningTeams.map(function (team) {
    return team.name;
  }) : [];
  return defaultOwningTeamNames;
}